import styled, { css } from 'styled-components';
import { Alert as AlertAntd } from 'antd';
import color from '../../configs/color';

const Alert = styled(AlertAntd)`
  border-radius: 12px;
  margin-bottom: 24px;
  align-items: center;
  padding: 12px;
  .ant-alert-message {
    color: ${color.black2};
  }
  .ant-alert-icon {
    ${(props) => {
      return (
        props.type === 'success' &&
        css`
          color: ${color.green1} !important;
        `
      );
    }}
    ${(props) => {
      return (
        props.type === 'info' &&
        css`
          color: ${color.purple1} !important;
        `
      );
    }}
    ${(props) => {
      return (
        props.type === 'warning' &&
        css`
          color: ${color.orange1} !important;
        `
      );
    }}
    ${(props) => {
      return (
        props.type === 'error' &&
        css`
          color: ${color.red1} !important;
        `
      );
    }}
  }
  .ant-alert-with-description,
  .ant-alert-icon {
    font-size: 20px;
  }
  ${(props) => {
    return (
      props.greyBG &&
      css`
        border-color: ${color.grey3};
        background-color: ${color.grey3};
        padding: 8px 15px;
      `
    );
  }}
  ${(props) => {
    return (
      props.type === 'warning' &&
      css`
        border-color: ${color.orange6} !important;
        background-color: ${color.orange6} !important;
      `
    );
  }}
`;

export default Alert;
